const chromeMatch = navigator.userAgent.indexOf("Chrome") > -1;
const safariMatch = navigator.userAgent.indexOf("Safari") > -1;

export const isSafari = () => safariMatch && !chromeMatch;
